import $ from 'jquery'

export default () => {
    $(document).ready(() => {
        $('form').on('ajaxFail', (event, request, options, text) => {
            if (text.responseJSON.flashMessage) {
                let errorClass = text.responseJSON.errorClass ? text.responseJSON.errorClass : 'error'
                $.oc.flashMsg({
                    text: text.responseJSON.flashMessage,
                    class: errorClass,
                })
            }
        })
    })
}
